"use strict";

import ModalManager from "./ModalManager";
import Modal, { showMessage, closeMessage } from "./Modal";

export { ModalManager, showMessage, closeMessage };

export default Modal;
